import { getDtfrmt } from "../../../utils";
import {
  CREATE_PROJECT_START,
  CREATE_PROJECT_SUCCESS,
  CREATE_PROJECT_FAILURE,
  INIT,
  LOADING,
  ERROR,
  SUCCESS,
  UPDATED,
  COPIED,
  FETCH_PROJECT_START,
  FETCH_PROJECT_SUCCESS,
  FETCH_ALL_PROJECT_SUCCESS,
  FETCH_PROJECT_FAILURE,
  SET_PROJECTS_INIT,
  FETCHPROJS,
  UPDATE_PROJECT_START,
  UPDATE_PROJECT_SUCCESS,
  UPDATE_PROJECT_FAILURE,
  COPY_PROJECT_START,
  COPY_PROJECT_SUCCESS,
  COPY_PROJECT_FAILURE,
  FETCH_MASTER_PROJECT_START,
  FETCH_MASTER_PROJECT_SUCCESS,
  FETCH_MASTER_PROJECT_FAILURE,
  MERGE_IMPORTED_TAGS,
  FETCH_PACKAGE_START,
  FETCH_PACKAGE_SUCCESS,
  FETCH_PACKAGE_FAILURE,
  CREATE_PACKAGE_START,
  CREATE_PACKAGE_SUCCESS,
  CREATE_PACKAGE_FAILURE,
  CREATE_TAG_SUCCESS,
  CREATE_TAG_START,
  CREATE_TAG_FAILURE,
  RESET_PKGS_TAGS,
  FETCH_TAGS_FAILURE,
  FETCH_TAGS_SUCCESS,
  FETCH_TAGS_START, GET_REPORT_SUCCESS,
  SWITCH_PKG_TAGS,
  SWITCH_TAG_PKG,
  UPDATE_TAGS_START,
  UPDATE_TAGS_SUCCESS,
  FETCH_ADNAMES_START,
  FETCH_ADNAMES_SUCCESS,
  HIDE_PROGRESS_BAR,
  CREATE_PKG_START,
  RESET_TAGS,
  CREATE_PKG_SUCCESS,
  REFRESH_TAGS_STATUS,
  CREATE_PKG_FAILURE,
  FETCH_PKGS_START,
  FETCH_PKGS_SUCCESS,
  PKGS_UPDATE_STATUS,
  FETCH_PKGS_FAILURE,
  UPDATE_PKG_START,
  UPDATE_PKG_SUCCESS,
  UPDATE_PKG_FAILURE,
  HIDE_PKG_NAV,
  CREATE_TTYPE_START,
  CREATE_TTYPE_SUCCESS,
  CREATE_TTYPE_FAILURE,
  FETCH_TTYPES_START,
  FETCH_TTYPES_SUCCESS,
  SWITCH_TAG_TT,
  SWITCH_TT_TAG,
  SWITCH_CATEGORY_TAGS,
  FETCH_TAG_COUNT_START,
  FETCH_TAG_COUNT_SUCCESS,
  FETCH_TAG_COUNT_FAILURE,
  UPDATE_PROGRESS_COUNT,
  SHOW_PROGRESS_BAR,
  FETCH_TAGS_CANCEL,
  SWITCH_INSTYPE_TAGS,
  SWITCH_DATASET,
  SWITCH_DATASET_CHILD,
  COPY_TAGS_START,
  COPY_TAGS_SUCCESS,
  COPY_TAGS_FAILURE,
  REMOVE_TAGS_START,
  REMOVE_TAGS_SUCCESS,
  REMOVE_TAGS_FAILURE,
  FETCH_MODEL_BREAK_START,
  FETCH_MODEL_BREAK_SUCCESS,
  FETCH_MODEL_BREAK_FAILURE,
  FETCH_MODEL_BREAK_MUL_START,
  FETCH_MODEL_BREAK_MUL_SUCCESS,
  FETCH_MODEL_BREAK_MUL_FAILURE,
  ADD_UPDATE_PRICE_CONFIG,
  ADD_UPDATE_PRICE_CONFIG_SUCCESS,
  ADD_UPDATE_PRICE_CONFIG_FAILURE,
  UPDATE_TAGS_RESPONSE,
  DELETE_TAGS_RESPONSE,
  USER_EXPIRE_LOGOUT,
  REPORT_BATCHES_START,
  REPORT_BATCHES_SUCCESS,
  REPORT_BATCHES_FAILURE,
  REPORT_BATCHES_RESET,
  DELETE_TAGS_START,
  RESTORE_TAGS_START,
  FETCH_REPORT_HUB_STATUS_SUCCESS,
  FETCH_REPORT_HUB_STATUS_START,
  CLEAR_REPORT_HUB_STATUS,
  REPORTHUB_TASK_STATUS_UPDATE,
  REPORTHUB_TASK_STATUS_START,
  SEND_MAIL_START,
  SEND_MAIL_SUCCESS,
  SEND_MAIL_FAILURE,
  FETCH_ARCHIVE_CANCEL,
  COPY_PKG_SUCCESS,
  COPY_PKG_INIT,
  BULK_TAG_CONFIG_FAILURE,
  BULK_TAG_CONFIG_SUCCESS,
  BULK_TAG_CONFIG_START,
  BULK_TAG_CONFIG_STS_START,
  BULK_TAG_CONFIG_STS_SUCCESS,
  BULK_TAG_CONFIG_STS_FAILURE,
  SEND_PRICING_DATA_START,
  SEND_PRICING_DATA_SUCCESS,
  SEND_PRICING_DATA_FAILURE,
  BULK_TAG_CONFIG_CANCEL_FAILURE,
  BULK_TAG_CONFIG_CANCEL_SUCCESS,
  BULK_TAG_CONFIG_CANCEL_START,
  CHANGE_LOADING_PHASE_STS,
  FETCH_TAG_COUNT_PKG_START,
  FETCH_TAG_COUNT_PKG_SUCCESS,
  FETCH_TAG_COUNT_PKG_FAILURE,
  GET_REPORT_START,
  START_LOADER,
  STOP_LOADER,
  ITEM_PRICE_STS_START,
  ITEM_PRICE_STS_SUCCESS,
  ITEM_PRICE_STS_FAILURE,
  PRICE_ITEM_SUCCESS,
  PRICE_ITEM_FAILURE,
  QUOTE_SEARCH_SUCCESS,
  QUOTE_SEARCH_FAILURE,
  CLEAR_QUOTE_SEARCH,
  QUOTE_SEARCH_START,
  FETCH_TAGS_WITH_CMNT_START,
  FETCH_TAGS_WITH_CMNT_SUCCESS,
  FETCH_TAGS_WITH_CMNT_FAILURE,
  CLEAR_TAGS_WITH_CMNT,
  FETCH_PKG_CMT_HISTORY_SUCCESS,
  FETCH_PKG_CMT_HISTORY_FAILURE,
  FETCH_PKG_CMT_HISTORY_START,
  UPDATE_PKG_CMT_START,
  UPDATE_PKG_CMT_SUCCESS,
  UPDATE_PKG_CMT_FAILURE,
  UPDATE_PKG_CMT_DELETE,
  EDIT_PKG_CMT_START,
  EDIT_PKG_CMT_SUCCESS,
  EDIT_PKG_CMT_FAILURE,
  CONF_IT_MODEL_STRING_BREAKDOWN_FAILURE,
  CONF_IT_MODEL_STRING_BREAKDOWN_START,
  CONF_IT_MODEL_STRING_BREAKDOWN_SUCCESS
} from "./projTypes";
import { delay } from "redux-saga/effects";

export const initialState = {
  getModelBreak: [],
  getModelBreakMul: [],
  projects: [],
  master_projects: [],
  errors: [],
  phase: INIT,
  copyPhase: INIT,
  tagStatusRF: false,
  packages: [],
  getPkgs: [],
  techTyps: [],
  techTypsChild: [],
  tags: [],
  deletedTags: [],
  tagsChild: [],
  adSearch: [],
  reportHubStatus: [],
  reportHubStatusCopy: [],
  tagCount: null,
  gettagcnt: null,
  reportHubTaskID: "",
  ttlDataToBefetch: 0,
  fetchedDataCnt: 0,
  resMesg: null,
  expiredLogout: false,
  ttlDataToBefetch: 0,
  showProgressBar: false,
  fetchedDataCnt: 0,
  resMesg: null,
  expiredLogout: false,
  copyPackageStatus: false,
  pricingTags: [],
  bulkUpdatedTags: [],
  loadingPhase: { action: "", phase: 'INIT', message: {} },
  bulkUpdTagStatus: INIT,
  reportHub: INIT,
  reportBatchesPhase: INIT,
  reportBatchesResponse: null,
  reportBatchesError: null,
  ongoingBatches: 0,
  itemPriceStatus: [],
  quoteSearchResults: {},
  tagsWithComments: {},
  pkgRevsCmnts: [],
  pkgRevsCmntsArray: []
};

function sortDeccompare(a, b) {
  if (+a.batch_id < +b.batch_id)
    return 1;
  if (+a.batch_id > +b.batch_id)
    return -1;
  return 0;
}

const configuredTags = (tags, conProcsedTag) => {
  const filteredbulkConfTags = conProcsedTag.reduce((prev, curr) => {
    if (!prev.some(obj => obj.tag_id === curr.tag_id && +obj.batch_id > +curr.batch_id)) {
      prev.push(curr);
    }
    return prev;
  }, []);


  const newTagsList = tags?.map((tag) => {
    const bulkConfigProcessTag = filteredbulkConfTags?.find((ele) => ele.tag_id === tag.tag_id)


    if (bulkConfigProcessTag != null && bulkConfigProcessTag != undefined) {
      let updatedTagsValue = {};

      if (bulkConfigProcessTag?.tag_table_updated_json) {

        const updatedTagsJSON = JSON.parse(bulkConfigProcessTag?.tag_table_updated_json)
        //console.log(updatedTagsJSON.config_status)
        if ((tag.config_status?.toUpperCase().includes("UNCONFIG") ||
          tag.config_status?.toUpperCase().includes("INVAL-PRICE") ||
          tag.config_status?.toUpperCase().includes("COPIED") ||
          tag.config_status?.toUpperCase().includes("INVALID") ||
          tag.config_status?.toUpperCase().includes("VALID")
        ) && updatedTagsJSON.config_status.includes("INPROCESS")) {
          updatedTagsValue = {
            ...updatedTagsJSON,
            config_status: updatedTagsJSON?.config_status
          }
        }
        else if ((tag.config_status?.toUpperCase().includes("INPROCESS")
        )) {
          updatedTagsValue = {
            ...updatedTagsJSON,
            // config_status: tag?.config_status
            config_status: updatedTagsJSON?.config_status
          }
        } else if ((tag.config_status?.toUpperCase().includes("VALID") && updatedTagsJSON.config_status.includes("VALID")) && (tag.configuration_import?.toUpperCase().includes("INPROCESS") && bulkConfigProcessTag.configuration_import.includes("SUCCESS"))) {
          updatedTagsValue = {
            ...updatedTagsJSON,
            config_status: updatedTagsJSON?.config_status
          }
        }
        // else {
        //   updatedTagsValue = {
        //     //...updatedTagsJSON,
        //     config_status: updatedTagsJSON?.config_status
        //   }
        // }

      } else {
        updatedTagsValue = {
          config_status: bulkConfigProcessTag?.delivery_status,
          configuration_import: bulkConfigProcessTag?.configuration_import
        }
      }
      console.log("--bulkConfigProcessTag--", bulkConfigProcessTag)
      return {
        ...tag,
        isBulkConfgProgress: (bulkConfigProcessTag?.delivery_status === "INPROCESS" || bulkConfigProcessTag?.delivery_status === "SUBMITTED") ? true : false,
        bulk_conf_request_by: bulkConfigProcessTag.request_by,
        ...updatedTagsValue
      }
    } else {
      return {
        ...tag,
        //isBulkConfgProgress: false,
        //bulk_conf_request_by: "" 
      }
    }
  })
  return newTagsList
}

const priceTags = (tags, priceProccesedTag) => {
  const insertTagList = tags?.map((tag) => {
    const pricingProcessTag = priceProccesedTag?.find((ele) => ele.tag_id = tag.tag_id)
    if (pricingProcessTag) {
      return { ...tag, isPricingProgress: true }
    }
    else {
      return { ...tag, isPricingProgress: false }
    }
  })
  return insertTagList
}

function transformRevisions(data) {
  // const map = new Map();

  // for (const item of data) {

  //   const key = `${item.package_id}_${item.revision_number}`;

  //   if (!map.has(key)) {
  //     map.set(key, {
  //       ...item,
  //       pkgRevHistory: []
  //     });
  //   }

  //   map.get(key).pkgRevHistory.push({ ...item });
  // }

  // // Convert to array
  // const result = Array.from(map.values());

  // // 🔥 Sort each pkgRevHistory by revision_id DESC
  // result.forEach(group => {
  //   group.pkgRevHistory.sort((a, b) => b.revision_id - a.revision_id);
  // });
  const map = new Map();

  for (const item of data) {

    const key = `${item.package_id}_${item.revision_number}`;

    if (!map.has(key)) {
      map.set(key, {
        pkgRevHistory: []
      });
    }
    if (item.revision_comments?.trim() == "") {
      item.revision_comments = "* No Comments *"
    }
    map.get(key).pkgRevHistory.push({ ...item });
  }

  const result = Array.from(map.values()).map(group => {

    // Sort history by revision_id DESC
    group.pkgRevHistory.sort((a, b) => b.revision_id - a.revision_id);

    // Make parent equal to greatest revision_id object
    return {
      ...group.pkgRevHistory[0],  // latest revision becomes parent
      pkgRevHistory: group.pkgRevHistory
    };

  });
  return result;
}

function transformRevisions1(data) {
  const grouped = {};

  // 1. Group by revision_number
  data.forEach(item => {
    const key = item.revision_number;
    if (!grouped[key]) grouped[key] = [];
    grouped[key].push(item);
  });

  const result = [];

  // 2. Process each revision group
  Object.values(grouped).forEach(group => {
    // sort by revision_id desc (latest first)
    group.sort((a, b) => b.revision_id - a.revision_id);

    const latest = { ...group[0] };

    // attach history
    // latest.pkgRevHistory = group.length > 1 ? [...group] : [];
    latest.pkgRevHistory = [...group];

    result.push(latest);
  });

  // 3. Optional: sort final result by revision_number asc
  return result.sort((a, b) => b.revision_number - a.revision_number);
}

export const projReducer = (state = initialState, action) => {
  // console.log({ action });
  let modelBreak = [];
  let pkgindex = null;
  let tagIndex = null;
  let projIndex = null;
  let newArrPkg = [];
  let newArrTT = [];
  let updArrPrj = [];
  let npkgs = [];
  //let newArrTag = [];
  let pkgIndex = null;
  let ttIndex = null;
  let updArrPkg = [];
  let chk = null;
  let favChng = true;
  switch (action.type) {
    case UPDATE_PROGRESS_COUNT:
      let count = state.fetchedDataCnt + action.count;
      return {
        ...state,
        fetchedDataCnt: count,
      };

    case SHOW_PROGRESS_BAR:
      console.log(action.payload);

      let obj = {
        ...state,
        showProgressBar: action.payload.isShow,
        fetchedDataCnt: action.payload.fetchedDataCnt,
      };
      if (action.payload.ttlDataCount.DP_Flow_tag_count != null) {
        obj["ttlDataToBefetch"] = action.payload.ttlDataCount.DP_Flow_tag_count;
      }
      return obj;

    case CREATE_PROJECT_START:
      return {
        ...state,
        phase: LOADING,
      };

    case CREATE_PROJECT_SUCCESS:
      updArrPrj = [...state.projects, action.cProj];
      updArrPrj.sort(
        (a, b) =>
          b.favorite?.localeCompare(a.favorite) || a.project_id - b.project_id
      );
      return {
        ...state,
        //phase: FETCHPROJS,
        phase: SUCCESS,
        projects: updArrPrj,
        //projects: [...state.projects, action.cProj],
      };
    case CREATE_PROJECT_FAILURE:
      return {
        ...state,
        phase: ERROR,
      };
    case UPDATE_PROJECT_START:
      return {
        ...state,
        phase: LOADING,
      };
    case UPDATE_PROJECT_SUCCESS:
      projIndex = state.projects.findIndex((o) => {
        return o.project_id === action.payload[0].project_id;
      });
      updArrPrj = [...state.projects];
      /*if (updArrPrj[projIndex].favorite === action.payload.favorite) {
      favChng = true;
    }else {favChng = false;}
    */
      let filterbyEmail = action.payload.filter((item) => item.email_id === updArrPrj[projIndex].email_id);

      updArrPrj[projIndex] = filterbyEmail[0];
      //if(!favChng){
      updArrPrj.sort(
        (a, b) =>
          b.favorite?.localeCompare(a.favorite) || a.project_id - b.project_id
      );
      //}
      return {
        ...state,
        //phase: FETCHPROJS,
        phase: SUCCESS,
        projects: updArrPrj,
      };
    case UPDATE_PROJECT_FAILURE:
      return {
        ...state,
        phase: ERROR,
      };
    case FETCH_PROJECT_START:
      if (action.payload.needToReload) {
        return {
          ...state,
          phase: LOADING,
          projects: [],
          projectsCnt: 0,
        };
      } else {
        return {
          ...state,
          phase: LOADING,
          projectsCnt: 0,
        }
      }
    case FETCH_PROJECT_SUCCESS:
      let aPkgs = [...state.projects];
      action.payload.map((values, index) => {
        aPkgs.push(values);
      });
      aPkgs.sort(
        (a, b) =>
          (a.favorite === "Y" && b.favorite !== "Y") ? -1 :
            (a.favorite !== "Y" && b.favorite === "Y") ? 1 :
              a.project_id - b.project_id
      );
      return {
        ...state,
        //projects: action.payload,
        projects: aPkgs,
        projectsCnt: aPkgs.length,
        phase: SUCCESS,
        // packages: [],
        //tags:[]
      };
    case FETCH_ALL_PROJECT_SUCCESS:
      let aPkgs1 = [...state.projects];
      action.payload.map((values, index) => {
        aPkgs1.push(values);
      });
      aPkgs1.sort(
        (a, b) =>
          (a.favorite === "Y" && b.favorite !== "Y") ? -1 :
            (a.favorite !== "Y" && b.favorite === "Y") ? 1 :
              a.project_id - b.project_id
      );
      return {
        ...state,
        //projects: action.payload,
        projects: aPkgs1,
        phase: SUCCESS,
        // packages: [],
        //tags:[]

      };
    /*state.projects.push(...action.payload)
      return {
        ...state,
        projects: state.projects
      };*/
    case FETCH_PROJECT_FAILURE:
      return {
        ...state,
        phase: ERROR,
        errors: action.errors,
      };
    case SET_PROJECTS_INIT:
      return {
        ...state,
        phase: INIT,
      };
    case COPY_PROJECT_START:
      return {
        ...state,
        phase: LOADING,
      };
    case COPY_PROJECT_SUCCESS:
      let aPkgs2 = [...state.projects];
      action.payload.map((values, index) => {
        aPkgs2.push(values);
      });
      console.log('Updated projects:', aPkgs2);

      return {
        ...state,
        // phase: FETCHPROJS,
        projects: aPkgs2,
        projectsCnt: aPkgs2.length,
        phase: SUCCESS,
      };
    case COPY_PROJECT_FAILURE:
      return {
        ...state,
        phase: ERROR,
      };
    case FETCH_MASTER_PROJECT_START:
      return {
        ...state,
        phase: LOADING,
      };
    case FETCH_MASTER_PROJECT_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        master_projects: action.projects,
      };
    case FETCH_MASTER_PROJECT_FAILURE:
      return {
        ...state,
        phase: ERROR,
      };
    case FETCH_PACKAGE_START:
      return {
        ...state,
        phase: LOADING,
      };
    case FETCH_PACKAGE_SUCCESS:
      //npkgs=[...state.getPkgs]
      action.payload.map((o) =>
        npkgs.push({ value: o.package_id, label: o.package_name })
      );
      npkgs.sort(
        (a, b) =>
          b.favorite?.localeCompare(a.favorite) || a.package_id - b.package_id
      );
      return {
        ...state,
        phase: SUCCESS,
        packages: action.payload
          .sort((a, b) =>
            a.package_id + a.favorite < a.package_id + b.favorite ? -1 : 1
          )
          .reverse(),
        getPkgs: npkgs,
        //getPkgs: npkgs
        //getPkgs:  [...state.getPkgs, ...npkgs]
      };
    case FETCH_PACKAGE_FAILURE:
      return {
        ...state,
        phase: ERROR,
      };
    case CREATE_PACKAGE_START:
      return {
        ...state,
        phase: LOADING,
      };
    case CREATE_PACKAGE_SUCCESS:
      let newPkg = {
        value: action.packages.package_id,
        label: action.packages.package_name,
      };
      return {
        ...state,
        phase: INIT,
        packages: [...state.packages, action.packages],
        getPkgs: [...state.getPkgs, newPkg],
      };
    case CREATE_PACKAGE_FAILURE:
      return {
        ...state,
        phase: ERROR,
      };
    case CREATE_TAG_START:
      return {
        ...state,
        phase: LOADING,
      };
    case CREATE_TAG_SUCCESS:
      const cTags = action.cTag;
      const processedTags = cTags.map(tag => {
        const techType = state.techTyps.filter(
          (i) => i.product_description === tag.gen_prod_desc
        )[0];
        if (techType && techType.selected === "N") {
          return { ...tag, selected: "N" };
        }
        return tag;
      });

      return {
        ...state,
        phase: SUCCESS,
        tags: [...state.tags, ...processedTags],
      };
    case CREATE_TAG_FAILURE:
      return {
        ...state,
        phase: ERROR,
      };
    case RESET_PKGS_TAGS:
      return {
        ...state,
        tags: [],
        packages: [],
        bulkUpdatedTags: [],
        itemPriceStatus: []
      };

    case RESET_TAGS:
      return {
        ...state,
        tags: [],
        bulkUpdatedTags: [],
        deletedTags: [],
        itemPriceStatus: []
      };

    case FETCH_TAGS_START:
      return {
        ...state,
        phase: LOADING,
        loadingPhase: { action: "FETCH_TAGS", phase: 'START' }
      };

    case FETCH_TAGS_CANCEL:
      return {
        ...state,
        loadingPhase: { action: "FETCH_TAGS", phase: 'CANCEL' }
      };

    case FETCH_ARCHIVE_CANCEL:
      return {
        ...state,
        phase: SUCCESS,
        showProgressBar: false,
      };

    case FETCH_TAGS_SUCCESS:
      const deletedTags = [];
      const enabledTags = [];
      action?.tags?.forEach((tag) => {
        if (tag.tag_enabled && tag.tag_enabled === "N") {
          deletedTags.push(tag);
        } else if (tag.tag_enabled && tag.tag_enabled === "Y") {
          tag['bulk_conf_request_by'] = "User, Observe Status from <Bulk Config Status> window"//tag.created_by
          enabledTags.push(tag);
        }
      });
      //const tags11 = configuredTags(enabledTags, state.bulkUpdatedTags)
      return {
        ...state,
        phase: SUCCESS,
        deletedTags: [...state.deletedTags, ...deletedTags],
        tags: [...state.tags, ...enabledTags],
        loadingPhase: { action: "FETCH_TAGS", phase: 'SUCCESS' }
      };

    case MERGE_IMPORTED_TAGS:
      return {
        ...state,
        tags: action.tags,
      };

    case FETCH_TAGS_FAILURE:
      return {
        ...state,
        phase: ERROR,
        loadingPhase: { action: "FETCH_TAGS", phase: 'ERROR' }
      };
    case SWITCH_PKG_TAGS: {
      pkgindex = state.packages.findIndex(
        (o) => o.package_id == action.payload.package_id
      );
      newArrPkg = [...state.packages];
      newArrPkg[pkgindex].selected = action.payload.selected ? "Y" : "N";
      const nTT = [...state.techTyps];
      const newTT = nTT.map((eTT, i) =>
        eTT.package_id == action.payload.package_id
          ? { ...eTT, selected: action.payload.selected ? "Y" : "N" }
          : eTT
      );

      const nTags = [...state.tags];
      const newTags = nTags.map((etags, i) =>
        etags.package_id == action.payload.package_id
          ? { ...etags, selected: action.payload.selected ? "Y" : "N" }
          : etags
      );
      return {
        ...state,
        packages: newArrPkg,
        techTyps: newTT,
        tags: newTags,
      };
    }
    case SWITCH_TAG_PKG: {
      tagIndex = state.tags?.findIndex(
        (o) => o.tag_id === action.payload.tag_id
      );
      let newArrTag = [...state.tags];
      newArrTag[tagIndex].selected = action.payload.selected ? "Y" : "N";
      pkgindex = state.packages.findIndex(
        (o) => o.package_id === action.payload.package_id
      );
      newArrPkg = [...state.packages];
      let chkTags = [...newArrTag];
      chk = chkTags.find(
        (o) => o.package_id === action.payload.package_id && o.selected === "Y"
      );
      newArrPkg[pkgindex].selected = chk ? "Y" : "N";
      return {
        ...state,
        tags: newArrTag,
        packages: newArrPkg,
      };
    }
    case SWITCH_TAG_TT:
      tagIndex = state.tags.findIndex((o) => o.tag_id == action.payload.tag_id);
      const newArrTag = [...state.tags];
      newArrTag[tagIndex].selected = action.payload.selected ? "Y" : "N";

      newArrTT = [...state.techTyps];
      let chkTags = [...newArrTag];

      chk = chkTags.find(
        (o) =>
          o.package_id == action.payload.package_id &&
          o.technology_id == action.payload.technology_id &&
          o.selected === "Y"
      );

      ttIndex = state.techTyps.findIndex(
        (o) => o.technology_id == action.payload.technology_id
      );

      newArrTT[ttIndex].selected = chk ? "Y" : "N";

      newArrPkg = [...state.packages];
      chk = newArrTT.find(
        (o) => o.package_id == action.payload.package_id && o.selected == "Y"
      );

      pkgindex = state.packages.findIndex(
        (o) => o.package_id == action.payload.package_id
      );

      newArrPkg[pkgindex].selected = chk ? "Y" : "N";

      return {
        ...state,
        packages: newArrPkg,
        tags: newArrTag,
        techTyps: newArrTT,
      };
    case SWITCH_TT_TAG:
      newArrTT = [...state.techTyps];
      ttIndex = state.techTyps.findIndex(
        (o) => o.technology_id == action.payload.technology_id
      );
      newArrTT[ttIndex].selected = action.payload.selected ? "Y" : "N";
      const nTags = [...state.tags];
      const newTags = nTags.map((etags, i) =>
        etags.package_id == action.payload.package_id &&
          etags.technology_id == action.payload.technology_id
          ? { ...etags, selected: action.payload.selected ? "Y" : "N" }
          : etags
      );

      newArrPkg = [...state.packages];
      chk = newArrTT.find(
        (o) => o.package_id == action.payload.package_id && o.selected == "Y"
      );

      pkgindex = state.packages.findIndex(
        (o) => o.package_id == action.payload.package_id
      );

      newArrPkg[pkgindex].selected = chk ? "Y" : "N";

      return {
        ...state,
        packages: newArrPkg,
        techTyps: newArrTT,
        tags: newTags,
      };

    case SWITCH_CATEGORY_TAGS:
      newArrTT = [...state.techTyps];
      let nTags2 = [...state.tags];
      let newTags2 = [];
      let newArrTT2 = [];

      // action.payload.technology_ids.forEach((technology_id)=>{
      //   ttIndex = state.techTyps.findIndex(
      //     (o) => o.technology_id == technology_id
      //   );
      //   newArrTT[ttIndex].selected = action.payload.selected ? "Y" : "N";
      // })

      newArrTT2 = newArrTT.map((tt) =>
        tt.technology_name == action.payload.category
          ? { ...tt, selected: action.payload.selected ? "Y" : "N" }
          : tt
      );

      newTags2 = nTags2.map((etags, i) =>
        etags.technology_name == action.payload.category
          ? { ...etags, selected: action.payload.selected ? "Y" : "N" }
          : etags
      );

      newArrPkg = [...state.packages];
      chk = newArrTT2.find(
        (o) => o.package_id == action.payload.package_id && o.selected == "Y"
      );

      pkgindex = state.packages.findIndex(
        (o) => o.package_id == action.payload.package_id
      );

      newArrPkg[pkgindex].selected = chk ? "Y" : "N";

      return {
        ...state,
        packages: newArrPkg,
        techTyps: newArrTT2,
        tags: newTags2,
      };

    case SWITCH_DATASET:
      newArrTT = [...state.techTyps];
      let nTags4 = [...state.tags];
      let newTags4 = [];
      let newArrTT4 = [];

      newArrTT4 = newArrTT.map((tt) =>
        tt.technology_name == action.payload.category
          ? { ...tt, selected: "Y" }
          : { ...tt, selected: "N" }
      );

      newTags4 = nTags4.map((etags, i) =>
        etags.technology_name == action.payload.category
          ? { ...etags, selected: "Y" }
          : { ...etags, selected: "N" }
      );

      newArrPkg = [...state.packages];
      chk = newArrTT4.find(
        (o) => o.package_id == action.payload.package_id && o.selected == "Y"
      );

      pkgindex = state.packages.findIndex(
        (o) => o.package_id == action.payload.package_id
      );

      newArrPkg[pkgindex].selected = chk ? "Y" : "N";
      return {
        ...state,
        packages: newArrPkg,
        techTyps: newArrTT4,
        tags: newTags4,
      };

    case SWITCH_DATASET_CHILD:
      newArrTT = [...state.techTyps];
      let nTags4Child = [...state.tags];
      let newTags4Child = [];
      let newArrTT4Child = [];

      newArrTT4Child = newArrTT.map((tt) =>
        tt.technology_name == action.payload.category
          ? { ...tt, selected: "Y" }
          : { ...tt, selected: "N" }
      );

      newTags4Child = nTags4Child.map((etags, i) =>
        etags.technology_name == action.payload.category
          ? { ...etags, selected: "Y" }
          : { ...etags, selected: "N" }
      );

      newArrPkg = [...state.packages];
      chk = newArrTT4Child.find(
        (o) => o.package_id == action.payload.package_id && o.selected == "Y"
      );

      pkgIndex = state.packages.findIndex(
        (o) => o.package_id == action.payload.package_id
      );

      let selectedRow = action.payload.selectedRow;
      newTags4Child = newTags4Child.filter(
        (item) =>
          item.tag_id !== selectedRow.tag_id &&
          item.gen_prod_desc === selectedRow.gen_prod_desc &&
          item.gen_technology_type === selectedRow.gen_technology_type &&
          item.gen_instrument_type === selectedRow.gen_instrument_type &&
          item.gen_costing_status !== "IN PROCESS"
      );
      newArrPkg[pkgIndex].selected = chk ? "Y" : "N";
      newTags4Child.sort((valueA, valueB) => {
        const valueALower = valueA.tag_number.toLowerCase();
        const valueBLower = valueB.tag_number.toLowerCase();
        return valueALower?.localeCompare(valueBLower, "en", { numeric: true });
      });
      return {
        ...state,
        packages: newArrPkg,
        techTypsChild: newArrTT4Child,
        tagsChild: newTags4Child,
        selectedTechnologyType: selectedRow.gen_technology_type,
      };

    case SWITCH_INSTYPE_TAGS:
      newArrTT = [...state.techTyps];
      let nTags1 = [...state.tags];
      let newTags1 = [];
      let newArrTT3 = [];

      // action.payload.technology_ids.forEach((technology_id)=>{
      //   ttIndex = state.techTyps.findIndex(
      //     (o) => o.technology_id == technology_id
      //   );
      //   newArrTT[ttIndex].selected = action.payload.selected ? "Y" : "N";
      // })

      newArrTT3 = newArrTT.map((tt) =>
        tt.instrument_type == action.payload.instrumentType
          ? { ...tt, selected: action.payload.selected ? "Y" : "N" }
          : tt
      );

      newTags1 = nTags1.map((etags, i) =>
        etags.gen_instrument_type == action.payload.instrumentType
          ? { ...etags, selected: action.payload.selected ? "Y" : "N" }
          : etags
      );

      newArrPkg = [...state.packages];
      chk = newArrTT3.find(
        (o) => o.package_id == action.payload.package_id && o.selected == "Y"
      );

      pkgindex = state.packages.findIndex(
        (o) => o.package_id == action.payload.package_id
      );

      newArrPkg[pkgindex].selected = chk ? "Y" : "N";

      return {
        ...state,
        packages: newArrPkg,
        techTyps: newArrTT3,
        tags: newTags1,
      };

    case UPDATE_TAGS_START:
      return {
        ...state,
        phase: action.tag?.loading ? action.tag?.loading : LOADING,
      };
    case UPDATE_TAGS_SUCCESS: {
      tagIndex = state.tags?.findIndex(
        (o) => o.tag_id === action.payload.tag.tag_id
      );
      let newArrTag = [...state.tags];
      newArrTag[tagIndex] = action.payload.tag;
      return {
        ...state,
        phase: UPDATED,
        //tags: [...state.tags,newArrTag]
        tags: newArrTag,
        tagStatusRF: false,
      };
    }
    case REFRESH_TAGS_STATUS:
      return {
        ...state,
        tagStatusRF: true,
      };
    case FETCH_ADNAMES_START:
      return {
        ...state,
        loading: true,
        phase: LOADING,
      };
    case FETCH_ADNAMES_SUCCESS:
      return {
        ...state,
        adSearch: action.adSearch.value,
        loading: false,
        phase: SUCCESS,
      };
    case CREATE_PKG_START:
      return {
        ...state,
        phase: LOADING,
      };
    case CREATE_PKG_SUCCESS:
      let project_id = action.project_id;

      if (project_id === action.cPkg?.project_id) {
        return {
          ...state,
          phase: SUCCESS,
          packages: [...state.packages, action.cPkg],
          loadingPhase: { action: "CREATE_PKG", phase: 'SUCCESS', message: {} },
          copyPackageStatus: false
        };
      } else if (action.cPkg?.status == "error") {
        return {
          ...state,
          phase: SUCCESS,
          loadingPhase: { action: "CREATE_PKG", phase: 'ERROR', message: { "msg": action.cPkg?.message } },

          copyPackageStatus: false
        }
      } else {
        return {
          ...state,
          phase: SUCCESS,
          loadingPhase: { action: "CREATE_PKG", phase: 'SUCCESS', message: {} },
          packages: state.packages,
          copyPackageStatus: true
        }
      }
    case CREATE_PKG_FAILURE:
      return {
        ...state,
        phase: ERROR,
      };
    case COPY_PKG_INIT:
      return {
        ...state,
        copyPhase: INIT,
      };
    case COPY_PKG_SUCCESS:
      return {
        ...state,
        copyPhase: COPIED,
      };

    case PKGS_UPDATE_STATUS:
      let sts_updted_Pkgs = [...state.packages];
      if (action?.fPkg) {
        sts_updted_Pkgs = sts_updted_Pkgs.map((a) => {
          if (a.project_id == action?.fPkg.project_id && a.package_id == action?.fPkg.package_id) {
            a["in_progress"] = action?.fPkg.in_progress
          }
          return a
        })
      }

      return {
        ...state,
        packages: sts_updted_Pkgs,
        //tags:[]
      };

    case FETCH_PKGS_START:
      return {
        ...state,
        phase: LOADING,
      };
    case FETCH_PKGS_SUCCESS:
      let sPkgs =
        action.fPkgs.length > 0
          ? action.fPkgs.sort(
            (a, b) =>
              b.favorite?.localeCompare(a.favorite) ||
              a.package_id - b.package_id
          )
          : [];
      return {
        ...state,
        packages: sPkgs,
        phase: SUCCESS,
        //tags:[]
      };
    case FETCH_PKGS_FAILURE:
      return {
        ...state,
        phase: ERROR,
        errors: action.errors,
      };
    case UPDATE_PKG_START:
      return {
        ...state,
        phase: LOADING,
      };
    case UPDATE_PKG_SUCCESS:
      pkgIndex = state.packages.findIndex(
        (o) => o.package_id === action.uPkg.package_id
      );
      updArrPkg = [...state.packages];
      updArrPkg[pkgIndex] = action.uPkg;
      updArrPkg.sort(
        (a, b) =>
          b.favorite?.localeCompare(a.favorite) || a.package_id - b.package_id
      );
      return {
        ...state,
        phase: SUCCESS,
        packages: updArrPkg,
      };
    case UPDATE_PKG_FAILURE:
      return {
        ...state,
        phase: ERROR,
      };
    case HIDE_PKG_NAV:
      return {
        ...state,
        packages: [],
      };
    case CREATE_TTYPE_START:
      return {
        ...state,
        phase: LOADING,
      };
    case CREATE_TTYPE_SUCCESS:
      let aTT = [...state.techTyps];
      let fTT;
      let eTT = [...state.techTyps];
      action.cTT.map((values, index) => {
        fTT = eTT.findIndex(
          (o) =>
            o.technology_name == values.technology_name &&
            o.instrument_type == values.instrument_type &&
            o.product_description == values.product_description
        );
        if (fTT < 0) {
          aTT.push(values);
        }
      });
      return {
        ...state,
        phase: SUCCESS,
        techTyps: aTT, //action.cTT, //[...state.techTyps, nTT], [...state.techTyps,action.cTT]
      };
    case CREATE_TTYPE_FAILURE:
      return {
        ...state,
        phase: ERROR,
      };
    case FETCH_TTYPES_START:
      return {
        ...state,
        phase: LOADING,
      };
    case FETCH_TTYPES_SUCCESS:
      return {
        ...state,
        techTyps: action.fTT,
        phase: SUCCESS,
        //packages: [],
        //tags:[]
      };
    case FETCH_TAG_COUNT_START:
      return {
        ...state,
        phase: LOADING,
      };
    case FETCH_TAG_COUNT_SUCCESS:
      return {
        ...state,
        tagCount: action.payload.tag_count,
        gettagcnt: action.payload,
        phase: SUCCESS,
      };
    case HIDE_PROGRESS_BAR:
      return {
        ...state,
        showProgressBar: false,
      };
    case FETCH_TAG_COUNT_FAILURE:
      return {
        ...state,
        phase: ERROR,
        errors: action.errors,
      };

    case COPY_TAGS_START:
      return {
        ...state,
        phase: LOADING,
      };
    case COPY_TAGS_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,

      };
    case COPY_TAGS_FAILURE:
      return {
        ...state,
        phase: ERROR,

      };
    case REMOVE_TAGS_START:
      return {
        ...state,
        phase: LOADING,

      };
    case REMOVE_TAGS_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,

      };
    case REMOVE_TAGS_FAILURE:
      return {
        ...state,
        phase: ERROR,

      };
    case FETCH_MODEL_BREAK_START:
      return {
        ...state,

        phase: LOADING,
      };

    case FETCH_MODEL_BREAK_SUCCESS:
      return {
        ...state,

        phase: SUCCESS,

        getModelBreak: action?.payload,
      };

    case FETCH_MODEL_BREAK_FAILURE:
      return {
        ...state,

        phase: ERROR,
      };

    case FETCH_MODEL_BREAK_MUL_START:
      return {
        ...state,

        phase: LOADING,
      };

    case FETCH_MODEL_BREAK_MUL_SUCCESS:
      return {
        ...state,

        phase: SUCCESS,

        getModelBreakMul: action?.payload,
      };

    case FETCH_MODEL_BREAK_MUL_FAILURE:
      return {
        ...state,

        phase: ERROR,
      };
    case ADD_UPDATE_PRICE_CONFIG:
      return {
        ...state,
        // phase: LOADING,
      };

    case ADD_UPDATE_PRICE_CONFIG_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
      };
    case ADD_UPDATE_PRICE_CONFIG_FAILURE:
      return {
        ...state,
        phase: ERROR,
      };
    case UPDATE_TAGS_RESPONSE:
      return {
        ...state,
        phase: UPDATED,
        resMesg: action.payload,
      };
    case DELETE_TAGS_RESPONSE:
      return {
        ...state,
        resMesg: null,
      };
    case USER_EXPIRE_LOGOUT:
      return {
        ...state,
        expiredLogout: true
      };

    case GET_REPORT_START:

      return {
        ...state,
        //reportHub: LOADING,
        //ongoingBatches: state.ongoingBatches + 1,
        //isLoading: true, // Explicitly set the loader to active
      };

    case GET_REPORT_SUCCESS:
      const newOngoingBatches = Math.max(0, state.ongoingBatches - 1);

      return {
        ...state,
        reportHubTaskID: action.payload,

      };

    case REPORT_BATCHES_START:
      return {
        ...state,
        reportBatchesPhase: LOADING,
        reportBatchesResponse: null,
        reportBatchesError: null,
      };

    case REPORT_BATCHES_SUCCESS:
      return {
        ...state,
        reportBatchesPhase: SUCCESS,
        reportBatchesResponse: action.payload,
        reportBatchesError: null,
      };

    case REPORT_BATCHES_FAILURE:
      return {
        ...state,
        reportBatchesPhase: ERROR,
        reportBatchesResponse: null,
        reportBatchesError: action.payload,
      };

    case REPORT_BATCHES_RESET:
      return {
        ...state,
        reportBatchesPhase: INIT,
        reportBatchesResponse: null,
        reportBatchesError: null,
      };

    case START_LOADER:
      // console.log("Loader started");
      return {
        ...state,
        reportHub: LOADING,
      };

    case STOP_LOADER:
      // console.log("Loader stopped");
      return {
        ...state,
        reportHub: INIT,
      };





    case DELETE_TAGS_START:
      let tempDelTags = [];
      let filteredDelTags = state.tags?.filter((tag) => !action.payload?.map(i => i.tag_id)?.includes(tag.tag_id))

      if (state.deletedTags.length != 0) {
        tempDelTags = state.deletedTags.concat(action.payload)
      }
      return {
        ...state,
        tags: filteredDelTags,
        deletedTags: tempDelTags
      };
    case RESTORE_TAGS_START:
      action.payload.map((tagId) => {
        state.deletedTags = state.deletedTags.filter(item => item.tag_id !== tagId.tag_id)
      })
      return {
        ...state,
        tags: state.tags.concat(action.payload)
      };
    case REPORTHUB_TASK_STATUS_START:
      return {
        ...state,
        phase: LOADING,
      }
    case FETCH_REPORT_HUB_STATUS_START:
      return {
        ...state,
        phase: LOADING,
      }
    case FETCH_REPORT_HUB_STATUS_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        reportHubStatusCopy: action.reportStatus,
        reportHubStatus: action.reportStatus,
      }
    case CLEAR_REPORT_HUB_STATUS:
      return {
        ...state,

        reportHubStatus: [],
      }
    case REPORTHUB_TASK_STATUS_UPDATE:
      let reportAll = [...state.reportHubStatus];
      let reportindex = reportAll.findIndex(
        (o) => o.task_id == action.reportStatusUpd.task_id
      )
      reportAll[reportindex].state = action.reportStatusUpd.state;
      return {
        ...state,
        phase: SUCCESS,
        reportHubStatus: reportAll,
      }
    case SEND_MAIL_START:
      return {
        ...state,
        phase: LOADING,
      };
    case SEND_MAIL_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
      };
    case SEND_MAIL_FAILURE:
      return {
        ...state,
        phase: ERROR,
      };
    // ---- Bulk TAG configuration--start--

    case BULK_TAG_CONFIG_START:
      return {
        ...state,
        loadingPhase: { action: "BULK_TAG_CONFIG", phase: 'START' },
      };

    case BULK_TAG_CONFIG_SUCCESS:
      let stateConfgObj = { ...state, loadingPhase: { action: "BULK_TAG_CONFIG", phase: 'SUCCESS', message: { ResponseStatus: action.payload.ResponseStatus, ErrorMessage: action.payload.ErrorMessage } } }

      if (action.payload.ResponseData.length > 0) {
        // const newTagsList = configuredTags(state.tags, newbulkConfigTags, "BULK_TAG")

        const newbulkConfigTags = [...state.bulkUpdatedTags, ...action.payload.ResponseData]
        const bulkConfTags = newbulkConfigTags.sort(sortDeccompare);
        const newTagsList = configuredTags(state.tags, bulkConfTags)
        stateConfgObj = {
          ...stateConfgObj,
          tags: newTagsList,
          bulkUpdatedTags: bulkConfTags
        }
      }

      return stateConfgObj;

    case BULK_TAG_CONFIG_FAILURE:
      return {
        ...state,
        loadingPhase: { action: "BULK_TAG_CONFIG", phase: 'ERROR' },
      };

    case BULK_TAG_CONFIG_STS_START:
      return {
        ...state,
        loadingPhase: { action: "BULK_TAG_CONFIG_STS", phase: 'START' },
      };

    case BULK_TAG_CONFIG_STS_SUCCESS:
      let stateSTSObj = { ...state, loadingPhase: { action: "BULK_TAG_CONFIG_STS", phase: 'SUCCESS' } }

      if (action.payload.length > 0) {
        // const newConfigTags = configuredTags(state.tags, action.payload, "BULK_TAG")
        const bulkConfStsTags = action.payload.sort(sortDeccompare);
        const newConfigTags = configuredTags(state.tags, bulkConfStsTags)
        console.log("newConfigTags", newConfigTags)
        stateSTSObj = {
          ...stateSTSObj,
          tags: newConfigTags,
          bulkUpdatedTags: bulkConfStsTags
        }
      }

      return stateSTSObj;

    case BULK_TAG_CONFIG_STS_FAILURE:
      return {
        ...state,
        loadingPhase: { action: "BULK_TAG_CONFIG_STS", phase: 'ERROR' },
      };

    case BULK_TAG_CONFIG_CANCEL_START:
      return {
        ...state,
        loadingPhase: { action: "BULK_TAG_CONFIG_CANCEL", phase: 'START' },
      };

    case BULK_TAG_CONFIG_CANCEL_SUCCESS:
      let stateCNCLObj = { ...state, loadingPhase: { action: "BULK_TAG_CONFIG_CANCEL", phase: 'SUCCESS' } }

      if (action.payload.length > 0) {

        const newConfigTags = configuredTags(state.tags, action.payload)
        // const newTagsList = state.tags?.map((tag) => {
        //   const bulkConfigProcessTag = action.payload?.find((ele) => ele.tag_id === tag.tag_id)


        //   if (bulkConfigProcessTag != null && bulkConfigProcessTag != undefined) {
        //     console.log("bulkConfigProcessTag", bulkConfigProcessTag)
        //     let updatedTagsValue = {};

        //     if (bulkConfigProcessTag?.tag_table_updated_json) {

        //       const updatedTagsJSON = JSON.parse(bulkConfigProcessTag?.tag_table_updated_json)
        //       console.log(updatedTagsJSON.config_status)
        //       updatedTagsValue = {
        //         ...updatedTagsJSON,
        //         isBulkConfgProgress:false,
        //         bulk_conf_request_by: ""
        //         //config_status: updatedTagsJSON?.config_status
        //       }
        //     } 
        //     console.log("updatedTagsValue", updatedTagsValue)
        //     return {
        //       ...tag,
        //       ...updatedTagsValue
        //     }
        //   } else {
        //     return { ...tag }
        //   }
        // })



        const newBulkTags = state.bulkUpdatedTags.map(bulkTag => {
          let payloadTag = action.payload.find(tag => bulkTag.tag_id === tag.tag_id && bulkTag.batch_id === tag.batch_id)
          if (payloadTag) {
            return payloadTag
          } else {
            return bulkTag
          }
        })

        stateCNCLObj = {
          ...stateCNCLObj,
          tags: newConfigTags,
          bulkUpdatedTags: newBulkTags
        }
      }

      return stateCNCLObj;

    case BULK_TAG_CONFIG_CANCEL_FAILURE:
      return {
        ...state,
        loadingPhase: { action: "BULK_TAG_CONFIG_CANCEL", phase: 'ERROR', message: { ErrorMessage: action.payload.detail } },
      };


    case CHANGE_LOADING_PHASE_STS:
      return {
        ...state,
        loadingPhase: { action: action.payload.action, phase: action.payload.phase, message: {} }
      }

    // ---- Bulk TAG configuration--end--

    case SEND_PRICING_DATA_START:
      return {
        ...state,
        phase: LOADING,
      };

    case SEND_PRICING_DATA_SUCCESS:
      // let statePricingObj = {...state, phase: SUCCESS}
      // if(action.payload.length>0){
      //   const priceTags = priceTags(action.payload)
      //   statePricingObj = {}
      // }
      console.log(action.payload, "payload in SEND_PRICING_DATA_SUCCESS")

      const pricedTags = [...state.tags]
      action.payload.updTags.forEach(tag => {
        const tagIndex = pricedTags.findIndex(i => i.tag_id == tag.tag_id)
        pricedTags[tagIndex].gen_costing_status = tag.gen_costing_status
      })


      //   let filteredPricingTags1 = state.tags?.map((tag) =>
      //     {
      //     if(action.payload?.includes(tag)){
      //       return {...tag,isPricingInProcess:true,}
      //     }else{
      //       return {...tag,isPricingInProcess:false,}
      //     }}
      // )
      console.log(pricedTags, "payload in SEND_PRICING_DATA_SUCCESS2")
      return {
        ...state,
        pricingTags: [...state.pricingTags, ...action.payload.updTags],
        tags: pricedTags,
        phase: SUCCESS,
      };

    case SEND_PRICING_DATA_FAILURE:
      return {
        ...state,
        phase: ERROR,
      };
    case FETCH_TAG_COUNT_PKG_START:
      return {
        ...state,
        phase: LOADING,
        bulkUpdTagStatus: LOADING
      }

    case FETCH_TAG_COUNT_PKG_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        // bulkUpdTagStatus: getInitialProps,
        bulkUpdTagStatus: "INIT",

      }
    case FETCH_TAG_COUNT_PKG_FAILURE:
      return {
        ...state,
        phase: ERROR,
        errors: action.errors,
      }
    //pricing code end

    case ITEM_PRICE_STS_START:
      return {
        ...state,
        loadingPhase: { action: "ITEM_PRICE_STS", phase: 'START' },
      };

    case ITEM_PRICE_STS_SUCCESS:
      const updatedTags = state.tags.map(tag => {
        const matchingStatusTag = action.payload.find(statusTag =>
          statusTag.tag_id == tag.tag_id && tag.config_status.includes('INPROCESS')
        );

        if (!matchingStatusTag) return tag;

        const newTag = { ...tag };

        if (matchingStatusTag.status === "SUCCESS") {
          const quantity = newTag.quantity || "1";
          const unitPrice = matchingStatusTag.api_response.listPrice;
          const sellPrice = matchingStatusTag.api_response.sellingPrice

          newTag.pur_unit_list_price1 = unitPrice;
          newTag.pur_total_unit_price = unitPrice;
          newTag.pur_sell_list_price1 = sellPrice;
          newTag.pur_total_sell_price = sellPrice;
          newTag.purchase_total_price = (Number(sellPrice) * Number(quantity)).toString();
          newTag.config_status = matchingStatusTag.config_status;
        } else if (matchingStatusTag.status === "FAILED") {
          newTag.pur_unit_list_price1 = null;
          newTag.pur_total_unit_price = null;
          newTag.pur_sell_list_price1 = null;
          newTag.pur_total_sell_price = null;
          newTag.purchase_total_price = null;
          newTag.config_status = matchingStatusTag.input_tag.config_status;
        }

        return newTag;
      });

      return {
        ...state,
        loadingPhase: { action: "ITEM_PRICE_STS", phase: 'SUCCESS' },
        itemPriceStatus: action.payload,
        tags: updatedTags,
      };

    case ITEM_PRICE_STS_FAILURE:
      return {
        ...state,
        loadingPhase: { action: "ITEM_PRICE_STS", phase: 'ERROR' },
      };

    case PRICE_ITEM_SUCCESS:
      const submittedTags = action.payload.payload.tags
      const allTags = [...state.tags];

      submittedTags.forEach(tag => {
        const tagIndex = allTags.findIndex(i => i.tag_id == tag.tag_id)
        if (tagIndex !== -1) {
          allTags[tagIndex] = {
            ...allTags[tagIndex],
            config_status: `INPROCESS-${getDtfrmt(new Date())}`,
          }
        }
      });

      return {
        ...state,
        tags: allTags,
        itemPriceStatus: action.payload.payload
      };

    case PRICE_ITEM_FAILURE:
      return {
        ...state,
        phase: ERROR,
      };
    // Quote search code start
    case QUOTE_SEARCH_FAILURE:
      return {
        ...state,
        phase: ERROR,
      };
    case QUOTE_SEARCH_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        quoteSearchResults: action.payload,
      };

    case CLEAR_QUOTE_SEARCH:
      return {
        ...state,
        quoteSearchResults: {},
      };

    // get tags with comments
    case FETCH_TAGS_WITH_CMNT_START:
      return {
        ...state,
        loadingPhase: { action: "TAGS_WITH_CMNT", phase: 'START' }
      };
    case FETCH_TAGS_WITH_CMNT_SUCCESS:
      const { restData, pkgDetails } = action.payload;
      console.log("DATA--TagsCOMT", restData)
      const tagsWithComments = { ...state.tagsWithComments };
      const tagsByParentId = restData.reduce((tagsByRevision, tag) => {
        const revision = tag.revision ?? pkgDetails.rev;
        const parentId = pkgDetails.project_id + "" + pkgDetails.package_id + "R" + revision;
        const tagKey = [tag.tag_id, revision].join("|");
        const revisionTags = tagsByRevision.get(parentId) || new Map();
        revisionTags.set(tagKey, tag);
        tagsByRevision.set(parentId, revisionTags);
        return tagsByRevision;
      }, new Map());

      tagsByParentId.forEach((revisionTags, parentId) => {
        tagsWithComments[parentId] = Array.from(revisionTags.values());
      });

      return {
        ...state,
        tagsWithComments,
        loadingPhase: { action: "TAGS_WITH_CMNT", phase: 'SUCCESS' }
      };
    case FETCH_TAGS_WITH_CMNT_FAILURE:
      return {
        ...state,
        loadingPhase: { action: "TAGS_WITH_CMNT", phase: 'ERROR' },
        errors: action.errors,
      };
    case CLEAR_TAGS_WITH_CMNT:
      return {
        ...state,
        tagsWithComments: {},
      };

    case FETCH_PKG_CMT_HISTORY_START:
      return {
        ...state,
        loadingPhase: { action: "FETCH_PKG_CMT_HISTORY", phase: 'START' }
      };
    case FETCH_PKG_CMT_HISTORY_SUCCESS:
      console.log("DATA--FETCH_PKG_CMT_HISTORY_SUCCESS", action.payload)

      const pkgRevsCmntsoutput = transformRevisions(action.payload);
      console.log(pkgRevsCmntsoutput);

      return {
        ...state,
        pkgRevsCmnts: pkgRevsCmntsoutput,
        pkgRevsCmntsArray: action.payload,
        loadingPhase: { action: "FETCH_PKG_CMT_HISTORY", phase: 'SUCCESS' }
      };
    case FETCH_PKG_CMT_HISTORY_FAILURE:
      return {
        ...state,
        loadingPhase: { action: "FETCH_PKG_CMT_HISTORY", phase: 'ERROR' },
        errors: action.errors,
      };


    case UPDATE_PKG_CMT_START:
      return {
        ...state,
        loadingPhase: { action: "UPDATE_PKG_CMT", phase: 'START' }
      };

    case UPDATE_PKG_CMT_SUCCESS:
      console.log("DATA--FETCH_PKG_CMT_HISTORY_SUCCESS", action.payload)
      const pkgRevsCmntsUpdArr = Array.isArray(action.payload)
        ? [...state.pkgRevsCmntsArray, ...action.payload]
        : [...state.pkgRevsCmntsArray, action.payload]

      // let isExistInRevCmtState = false;

      // let updatedPkgRevsCmnts = state.pkgRevsCmnts.map(rev => {
      //   if (rev.revision_number === action.payload.revision_number && rev.package_id === action.payload.package_id && rev.project_id === action.payload.project_id) {
      //     rev.pkgRevHistory = [...rev.pkgRevHistory, action.payload]
      //     isExistInRevCmtState = true

      //   } return rev
      // });
      // if (!isExistInRevCmtState) {
      //   action.payload["pkgRevHistory"] = []
      //   updatedPkgRevsCmnts = [...updatedPkgRevsCmnts, action.payload]
      // }
      // console.log("updatedPkgRevsCmnts", updatedPkgRevsCmnts)
      const updatedPkgRevsCmnts = transformRevisions(pkgRevsCmntsUpdArr);
      console.log(updatedPkgRevsCmnts);

      return {
        ...state,
        pkgRevsCmnts: updatedPkgRevsCmnts,
        pkgRevsCmntsArray: pkgRevsCmntsUpdArr,
        // loadingPhase: { action: "UPDATE_PKG_CMT", phase: 'SUCCESS' }
      };

    case UPDATE_PKG_CMT_FAILURE:
      return {
        ...state,
        loadingPhase: { action: "UPDATE_PKG_CMT", phase: 'ERROR' },
        errors: action.errors,
      };

    case EDIT_PKG_CMT_START:
      return {
        ...state,
        loadingPhase: { action: "EDIT_PKG_CMT", phase: 'START' }
      };

    case EDIT_PKG_CMT_SUCCESS: {
      const editedComment = Array.isArray(action.payload) ? action.payload[0] : action.payload;
      const updatedCommentList = state.pkgRevsCmntsArray.map((item) => {
        if (
          item.revision_id === editedComment.revision_id &&
          item.package_id === editedComment.package_id &&
          item.project_id === editedComment.project_id &&
          item.revision_number === editedComment.revision_number
        ) {
          return { ...item, ...editedComment };
        }
        return item;
      }).filter(item => item.enabled_flag === 'Y'); // Filter out comments with enabled_flag 'N'
      const updatedPkgRevsCmnts = transformRevisions(updatedCommentList);

      return {
        ...state,
        pkgRevsCmnts: updatedPkgRevsCmnts,
        pkgRevsCmntsArray: updatedCommentList,
      };
    }

    case EDIT_PKG_CMT_FAILURE:
      return {
        ...state,
        loadingPhase: { action: "EDIT_PKG_CMT", phase: 'ERROR' },
        errors: action.errors,
      };

    case UPDATE_PKG_CMT_DELETE:
      console.log("DATA--UPDATE_PKG_CMT_DELETE", action.payload)
      const pkgRevsCmntsUpdArr_del = state.pkgRevsCmntsArray.filter(item => item.package_id !== action.payload.package_id && item.revision_number !== action.payload.revision_number)

      // let isExistInRevCmtState = false;

      // let updatedPkgRevsCmnts = state.pkgRevsCmnts.map(rev => {
      //   if (rev.revision_number === action.payload.revision_number && rev.package_id === action.payload.package_id && rev.project_id === action.payload.project_id) {
      //     rev.pkgRevHistory = [...rev.pkgRevHistory, action.payload]
      //     isExistInRevCmtState = true

      //   } return rev
      // });
      // if (!isExistInRevCmtState) {
      //   action.payload["pkgRevHistory"] = []
      //   updatedPkgRevsCmnts = [...updatedPkgRevsCmnts, action.payload]
      // }
      // console.log("updatedPkgRevsCmnts", updatedPkgRevsCmnts)
      const updatedPkgRevsCmnts_del = transformRevisions(pkgRevsCmntsUpdArr_del);
      console.log(updatedPkgRevsCmnts_del);

      return {
        ...state,
        pkgRevsCmnts: updatedPkgRevsCmnts_del,
        pkgRevsCmntsArray: pkgRevsCmntsUpdArr_del,
        loadingPhase: { action: "UPDATE_PKG_CMT", phase: 'SUCCESS' }
      };

    case CONF_IT_MODEL_STRING_BREAKDOWN_START:
      return {
        ...state,
        // phase: LOADING,
        loadingPhase: { action: "CONF_IT_MODEL_STRING_BREAKDOWN", phase: 'START' }
      };

    case CONF_IT_MODEL_STRING_BREAKDOWN_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        loadingPhase: { action: "CONF_IT_MODEL_STRING_BREAKDOWN", phase: 'SUCCESS' }
      };
    case CONF_IT_MODEL_STRING_BREAKDOWN_FAILURE:
      return {
        ...state,
        phase: ERROR,
        loadingPhase: { action: "CONF_IT_MODEL_STRING_BREAKDOWN", phase: 'ERROR' }
      };

    default:
      return state;
  }

};
